export interface ITipoControleGabinete {
    id: number;
    descricao: string;
    permiteExclusao?: boolean;
}

export enum TipoControle {

    IMPORTAR = 1,
    LISTAGEM,
    DISTRIBUIR,
    ASSINATURA,
    VISTOAPAUTA,
    AGUARDANDO,
    REDATORDESIGNADO,
    VOTOVENCIDO
}


class IMPORTAR implements ITipoControleGabinete {
    id = TipoControle.IMPORTAR;
    descricao = 'Importar';
    permiteExclusao = false;
}
class LISTAGEM implements ITipoControleGabinete {
    id = TipoControle.LISTAGEM;
    descricao = 'LISTAGEM';
    permiteExclusao = true;
}
class DISTRIBUIR implements ITipoControleGabinete {
    id = TipoControle.DISTRIBUIR;
    descricao = 'Não distribuído';
    permiteExclusao = false;
}
class ASSINATURA implements ITipoControleGabinete {
    id = TipoControle.ASSINATURA;
    descricao = 'Para assinatura';
    permiteExclusao = false;
}
class VISTOAPAUTA implements ITipoControleGabinete {
    id = TipoControle.VISTOAPAUTA;
    descricao = 'Visto à pauta';
    permiteExclusao = false;
}
class AGUARDANDO implements ITipoControleGabinete {
    id = TipoControle.AGUARDANDO;
    descricao = 'Aguardando julgamento';
    permiteExclusao = false;
}
class REDATORDESIGNADO implements ITipoControleGabinete {
    id = TipoControle.REDATORDESIGNADO;
    descricao = 'Redator Designado';
    permiteExclusao = false;
}
class VOTOVENCIDO implements ITipoControleGabinete {
    id = TipoControle.VOTOVENCIDO;
    descricao = 'Justificativa de Voto Vencido';
    permiteExclusao = false;
}

export const TIPO_CONTROLE_IMPORTAR = new IMPORTAR();
export const TIPO_CONTROLE_LISTAGEM = new LISTAGEM();
export const TIPO_CONTROLE_DISTRIBUIR = new DISTRIBUIR();
export const TIPO_CONTROLE_ASSINATURA = new ASSINATURA();
export const TIPO_CONTROLE_VISTOAPAUTA = new VISTOAPAUTA();
export const TIPO_CONTROLE_AGUARDANDO = new AGUARDANDO();
export const TIPO_CONTROLE_REDATORDESIGNADO = new REDATORDESIGNADO();
export const TIPO_CONTROLE_VOTO_VENCIDO = new VOTOVENCIDO();